import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {JwtService} from '../auth/services/jwt.service';
import {catchError, switchMap, throwError} from "rxjs";
import {UserService} from '../auth/services/user.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(JwtService);
  const userService = inject(UserService);

  const request = req.clone({
    setHeaders: {
      ...(tokenService.getToken() ? {Authorization: `Bearer ${tokenService.getToken()}`} : {}),
    },
  });
  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !req.url.includes('/authentication/refresh-token')&& !req.url.includes('/authentication/login')&& !req.url.includes('/authentication/register')) {
        return userService.refreshAccessToken().pipe(
          switchMap(() => next(req.clone({
            setHeaders: {Authorization: `Bearer ${tokenService.getToken()}`}
          })))
        );
      }
      return throwError(() => err);
    })
  );
};
